import type { StateCreator } from 'zustand';

import type { ChatHistory } from '@cobliteam/api-lib/src/dashboard/coblinator/Types';

interface PromptSliceState {
  isLoadingAIResponse: boolean;
  submitedUserPrompt?: string;
  currentPromptAIResponse?: ChatHistory;
  setIsLoadingAIResponse: (isLoadingAIResponse: boolean) => void;
  setCurrentPromptAIResponse: (currentPromptAIResponse?: ChatHistory) => void;
  setSubmitedUserPrompt: (submittedUserPrompt?: string) => void;
}

type StateCreatorPrompt = StateCreator<PromptSliceState, [['zustand/devtools', never]], [], PromptSliceState>;

const promptSlice: StateCreatorPrompt = (set) => ({
  isLoadingAIResponse: false,
  submitedUserPrompt: undefined,
  currentPromptAIResponse: undefined,
  setIsLoadingAIResponse: (isLoadingAIResponse) =>
    set(
      () => {
        return { isLoadingAIResponse };
      },
      false,
      'setIsLoadingAIResponse'
    ),
  setCurrentPromptAIResponse: (currentPromptAIResponse) =>
    set(
      () => {
        return { currentPromptAIResponse };
      },
      false,
      'setCurrentPromptAIResponse'
    ),
  setSubmitedUserPrompt: (submitedUserPrompt) =>
    set(
      () => {
        return { submitedUserPrompt };
      },
      false,
      'setSubmitedUserPrompt'
    ),
});

export type { PromptSliceState };
export default promptSlice;
